<template>
  <div :class="$style['wrapper']">
    <ds-confirmed-icon v-if="succeess" />
    <ds-unconfirmed-icon v-else />
    <div :class="$style['right-wrapper']">
      <div :class="$style['address']">{{ domain }}</div>
      <div :class="$style['response']">{{ response }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    succeess: {
      type: Boolean,
      default: true
    },
    domain: {
      type: String,
      default: ""
    },
    response: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" module>
@import "~@theme/scss/_variables.scss";

.wrapper {
  display: flex;
  svg {
    width: 40px;
    height: 40px;
  }
}
.address,
.response {
  font-weight: 600;
  line-height: 24px;
}
.address {
  color: $black-blue-color;
}
.response {
  font-weight: 600;
  color: $light-gray-color;
}
.right-wrapper {
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/record-response.vue